import type { GetPostFeedMetadataPageRequest } from '@wix/ambassador-blog-frontend-adapter-public-v2-post-feed-page-http/types';
import { SET_FEED_METADATA_PARAMS } from '../../actions/fetch-feed-metadata';
import { setPostListMetadataParams } from '../../actions/fetch-post-list-metadata';

interface FeedMetadataParamsAction {
  type: string;
  payload?: GetPostFeedMetadataPageRequest;
}

export const listMetadataParams = (
  state: GetPostFeedMetadataPageRequest | null = null,
  { type, payload }: FeedMetadataParamsAction = {} as FeedMetadataParamsAction,
): GetPostFeedMetadataPageRequest | null => {
  switch (type) {
    case setPostListMetadataParams.type:
    case SET_FEED_METADATA_PARAMS:
      return payload || null;
    default:
      return state;
  }
};
